import { EventEmitter } from '@angular/core';
import { ButtonDownloadComponent, ButtonDownloadDeleteComponent, ButtonViewAttachmentsComponent, ButtonViewFlowComponent } from '@app/shared';
import { DateFormatPipe } from '@app/shared/pipes/moment/date-format.pipe';
import { environment } from '@env/environment';


export class ProcedureMonitoringConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // se emite cada vez que se realiza una accion con los botones de la tabla de anexos
  accionAttachment: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};
  settingsAttachment = {};

  constructor(structure?:any) {
    const self = this;
    this.settings = {
        mode: 'external',
        noDataMessage: 'Actualmente no hay registros',
        actions: false,
        attr: {
          class: 'table-bordered table-hover'
        },
        columns:{
        }
      };
      if(structure!=undefined && structure.length){
        structure.forEach((st:any) =>{
          if(st["tipo"] == "texto"){
            this.settings["columns"][st["alias"]] = {
                editable: false,
                addable: false,
                title: st["nombre"],
                filter: {
                  inputClass: 'form-control',
                }
              }
          }else if (st["tipo"] == "fecha"){
            this.settings["columns"][st["alias"]] = {
              editable: false,
              addable: false,
              title: st["nombre"],
              filter: {
                inputClass: 'form-control',
              },
              valuePrepareFunction: (cell: any, row: any) => {
                const formatted = new DateFormatPipe().transform(row[st["alias"]]);
                return formatted;
              }
            }
          }
          else if (st["tipo"] == "boolean"){
            this.settings["columns"][st["alias"]] = {
              editable: false,
              addable: false,
              title: st["nombre"],
              filter: {
                inputClass: 'form-control',
              }
            }
          }
          else if (st["tipo"] == "descarga_documento"){
            this.settings["columns"][st["alias"]] = {
              title: st["nombre"],
              filter: false,
              type: 'custom',
              renderComponent: ButtonDownloadComponent,
              onComponentInitFunction(instance: any) {
                instance.save.subscribe((data: any) => {
                  // controla el evento click del boton
                  const sendData = {
                    'action': 'descargar',
                    'data': data,
                    'alias': st["alias"]
                  };
                  self.accion.emit(sendData);
                });
              }
            }
          }
          else if (st["tipo"] == "ver_flujo"){
            this.settings["columns"][st["alias"]] ={
              title: st["nombre"],
              filter: false,
              type: 'custom',
              renderComponent: ButtonViewFlowComponent,
              onComponentInitFunction(instance: any) {
                instance.save.subscribe((data: any) => {
                  // controla el evento click del boton
                  const sendData = {
                    action: "ver_flujo",
                    data: data,
                    alias: st["alias"]
                  };
                  self.accion.emit(sendData);
                });
              },
            }
          }
          else if (st["tipo"] == "ver_anexos"){
            this.settings["columns"][st["alias"]] ={
              title: st["nombre"],
              filter: false,
              type: 'custom',
              renderComponent: ButtonViewAttachmentsComponent,
              onComponentInitFunction(instance: any) {
                instance.save.subscribe((data: any) => {
                  // controla el evento click del boton
                  const sendData = {
                    action: "ver_anexos",
                    data: data,
                    alias: st["alias"]
                  };
                  self.accion.emit(sendData);
                });
              },
            }
          }
          
        });
      }
      this.settingsAttachment = {
        mode: 'external',
        noDataMessage: 'No hay archivos anexados a la tarea.',
        actions: false,
        attr: {
          class: 'table-bordered table-hover'
        },
        columns: {
          nombre: {
            title: 'Nombre del archivo',
            editable: false,
          },
          fecha_registro: {
            title: 'Fecha de anexado',
            editable: false,
          },
          id: {
            title: 'Accion',
            editable: false,
            filter: false,
            type: 'custom',
            renderComponent: ButtonDownloadDeleteComponent,
            onComponentInitFunction(instance: any) {
              instance.save.subscribe((data: any) => {
                // controla el evento click del boton
                self.accionAttachment.emit(data);
              });
            }
          },
        },
      };
      
    
    
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/procedure-monitoring/shared/procedure-monitoring.config.service.ts